const TOKEN_NAME = 'authToken'

const type = {
  UNKNOWN: 'unknown',
  LOG_IN: 'loggedIn',
  REGISTER: 'register',
} as const

export type AuthTypes = typeof type[keyof typeof type]

export { TOKEN_NAME, type as authType }
